import { createSlice } from "@reduxjs/toolkit";

const url = createSlice({
  name: "url",
  initialState: {
    // value: 'http://localhost:3333',
    value: 'http://188.166.149.66',
  }
})

export default url.reducer;